import { useState, type ReactElement } from "react";

import { passwordChecks, passwordStrength } from "../lib/password";

// A password input with a show/hide toggle and a live strength meter +
// criteria checklist (legacy activate_account/reset parity). The server
// remains the authoritative gate.
export function PasswordField({
  label,
  value,
  onChange,
  autoComplete = "new-password",
  placeholder = "At least 12 characters",
  showMeter = true,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  autoComplete?: string;
  placeholder?: string;
  showMeter?: boolean;
}): ReactElement {
  const checks = passwordChecks(value);
  const strength = passwordStrength(value);
  const [visible, setVisible] = useState(false);

  return (
    <label className="field">
      <span>{label}</span>
      <div className="pw-input-wrap">
        <input
          type={visible ? "text" : "password"}
          autoComplete={autoComplete}
          required
          minLength={12}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
        <button
          type="button"
          className="pw-toggle"
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>
      {showMeter && value.length > 0 ? (
        <div className="pw-meter" aria-live="polite">
          <div className="pw-bar">
            <div className={`pw-bar-fill pw-${strength.level}`} style={{ width: `${strength.pct}%` }} />
          </div>
          <ul className="pw-checks">
            <li className={checks.length ? "ok" : ""}>12+ characters</li>
            <li className={checks.upper ? "ok" : ""}>Uppercase</li>
            <li className={checks.lower ? "ok" : ""}>Lowercase</li>
            <li className={checks.digit ? "ok" : ""}>Number</li>
            <li className={checks.special ? "ok" : ""}>Symbol</li>
          </ul>
        </div>
      ) : null}
    </label>
  );
}
